import axios from 'axios';
import { API_URL } from '../config';
import api from './api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Check for existing contact with same email and message
export const checkExistingContact = async (email, message) => {
  const response = await api.post('/api/contact/check', { email, message });
  return response.data;
};

// Submit contact form
export const submitContactForm = async (formData) => {
  try {
    // Convert FormData to a plain object for logging
    const formDataObj = {};
    formData.forEach((value, key) => {
      formDataObj[key] = value;
    });
    console.log('Submitting form data:', formDataObj);

    const response = await api.post('/api/contact', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(error.response.data.message || 'Failed to submit contact form');
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response from server. Please check your internet connection.');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error('Error setting up the request. Please try again.');
    }
  }
};

// Admin endpoints
export const getAllContacts = async (params) => {
  const response = await axios.get(`${API_URL}/api/contact`, { 
    ...getAuthHeaders(),
    params 
  });
  return response.data;
};

export const getContactById = async (id) => {
  const response = await axios.get(`${API_URL}/api/contact/${id}`, getAuthHeaders());
  return response.data;
};

export const updateContactStatus = async (id, status) => {
  const response = await axios.patch(
    `${API_URL}/api/contact/${id}/status`, 
    { status },
    getAuthHeaders()
  );
  return response.data;
};

export const addContactNote = async (id, content) => {
  const response = await axios.post(
    `${API_URL}/api/contact/${id}/notes`, 
    { content },
    getAuthHeaders()
  );
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/contact/${id}`,
    getAuthHeaders()
  );
  return response.data;
};

export const getServiceRequests = async () => {
  const response = await axios.get(`${API_URL}/api/contact/service-requests`, getAuthHeaders());
  return response.data;
}; 